import { useContext } from "react";
import { AuthContext } from "../providers/authProviders";

export default function useAuth() {
  return useContext(AuthContext);
}
